<template>
  <BookmarkIconOutline
    v-if="!isBookmarked"
    class="h-5 w-5 inline-block cursor-pointer"
    title="Aggiungi ai preferiti"
    @click="addToBookmark"
  />
  <BookmarkIcon
    v-else
    class="h-5 w-5 inline-block text-yellow-400 cursor-pointer"
    title="Rimuovi dai preferiti"
    @click="removeFromBookmark"
  />
</template>

<script setup>
import { BookmarkIcon as BookmarkIconOutline } from '@heroicons/vue/24/outline';
import { BookmarkIcon } from '@heroicons/vue/24/solid';
import { useI18n } from 'vue-i18n'

import lotBookmark from '@/services/lot-bookmarks';
import { useNotificationsStore } from '@/stores/notifications';
const { pushSuccess } = useNotificationsStore();
const { t } = useI18n()

const props = defineProps({
    lot: {
        type: Object,
        required: true
    },
    isBookmarked: {
        type: Boolean,
        required: true
    }
})

const emit = defineEmits(['added', 'removed'])

const addToBookmark = function () {
    lotBookmark.add(props.lot.uuid)
    pushSuccess(t('lot.added_to_bookmark', {'lot': props.lot.code}))
    emit('added')
}

const removeFromBookmark = function () {
    lotBookmark.remove(props.lot.uuid)
    pushSuccess(t('lot.removed_from_bookmark', {'lot': props.lot.code}))
    emit('removed')
}
</script>